export const GET_CURRENT_USER = Symbol();
export const GET_CURRENT_USER_SUCCESS = Symbol();
export const GET_CURRENT_USER_ERROR = Symbol();

export const GET_LAYOUT_SETTINGS = Symbol();
export const GET_LAYOUT_SETTINGS_SUCCESS = Symbol();
export const GET_LAYOUT_SETTINGS_ERROR = Symbol();

export const LOGOUT = Symbol();